export const aboutContent = {
    caption: "THIS IS",
    title: "Angelina Kutuzova",
    description:
      "👩🏻‍💻🚀 With a solid background in Customer Success and a growing expertise in frontend development, I'm excited to bring my skills to new challenges. I'm currently looking for opportunities to contribute to innovative web projects."
  };
  
  export const footerContent = {
    caption: "LET'S TALK",
    description:
      "Let’s make your ideas come to life! If you’re working on a website, dashboard, or mobile app and need some help, don’t hesitate to get in touch. I’d love to collaborate."
  };